import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import getDashedTitle from '@/utilities/getDashedTitle';

export default function useBrowseArchivedResources() {
  const router = useRouter();
  const store = useStore();
  const teamSlug = store.getters.getTeamSlug;

  const resourceFilterOptions: Record<string, string> = {
    board: 'boards',
    project: 'projects',
  };

  const openArchivedCardsView = async (resourceId: string, resourceType: string) => {
    if (!resourceId || !resourceType) return;

    const resourceTypePlural = resourceFilterOptions[resourceType];
    if (!resourceTypePlural) return;

    const publicViews = store.getters.getPublicViews;
    const privateViews = store.getters.getPrivateViews;
    const existingViews = [...publicViews, ...privateViews];

    const existingView = existingViews?.find(
      (view: any) =>
        view.card_filters?.is_archived &&
        (view.card_filters?.include?.projects?.includes(resourceId) ||
          view.card_filters?.include?.boards?.includes(resourceId))
    );

    if (existingView) {
      const viewDashedTitle = getDashedTitle(existingView.name);
      await router.push(`/${teamSlug}/view-${existingView.id}-${viewDashedTitle}`);
    } else {
      const filters = {
        include: {
          [resourceTypePlural]: [resourceId],
        },
        exclude: {},
        is_archived: true,
      };

      store.dispatch('setViewFilters', filters);
      store.dispatch('setViewPills', [resourceTypePlural, 'is_archived']);

      const { cards, count } = await store.dispatch('fetchNewViewResults', {
        card_filters: { ...filters },
        type: 'card',
      });

      store.dispatch('setViewResults', cards);
      store.dispatch('currentViewTotalCount', count);

      await router.push({ name: 'newview' });
    }
  };

  return {
    openArchivedCardsView,
  };
}
